import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

export interface PaymentRateSettings {
  hours: number;
  days: number;
  months: number;
}

const SETTINGS_COLLECTION = 'app_settings';
const PAYMENT_RATES_DOC = 'payment_rates';

const DEFAULT_PAYMENT_RATES: PaymentRateSettings = {
  hours: 1000,
  days: 8000,
  months: 160000,
};

function toNumber(value: unknown, fallback: number): number {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const n = Number(value);
    if (Number.isFinite(n)) return n;
  }
  return fallback;
}

export async function getPaymentRateSettings(): Promise<PaymentRateSettings> {
  const ref = doc(db, SETTINGS_COLLECTION, PAYMENT_RATES_DOC);
  const snap = await getDoc(ref);
  if (!snap.exists()) return DEFAULT_PAYMENT_RATES;
  const data = snap.data() as Record<string, unknown>;
  return {
    hours: toNumber(data.hours, DEFAULT_PAYMENT_RATES.hours),
    days: toNumber(data.days, DEFAULT_PAYMENT_RATES.days),
    months: toNumber(data.months, DEFAULT_PAYMENT_RATES.months),
  };
}

export async function updatePaymentRateSettings(
  payload: PaymentRateSettings
): Promise<void> {
  const ref = doc(db, SETTINGS_COLLECTION, PAYMENT_RATES_DOC);
  await setDoc(
    ref,
    {
      hours: payload.hours,
      days: payload.days,
      months: payload.months,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

